/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as AdminDefs from '../../../com/atproto/admin/defs.defs.js'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs.js'
import * as ConvoDefs from '../../../chat/bsky/convo/defs.defs.js'
import * as ModerationDefs from '../../../com/atproto/moderation/defs.defs.js'
import * as AgeassuranceDefs from '../../../app/bsky/ageassurance/defs.defs.js'
import * as ServerDefs from '../../../com/atproto/server/defs.defs.js'
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js'

const $nsid = 'tools.ozone.moderation.defs'

export { $nsid }

type ModEventView = {
  $type?: 'tools.ozone.moderation.defs#modEventView'
  id: number
  event:
    | l.$Typed<ModEventTakedown>
    | l.$Typed<ModEventReverseTakedown>
    | l.$Typed<ModEventComment>
    | l.$Typed<ModEventReport>
    | l.$Typed<ModEventLabel>
    | l.$Typed<ModEventAcknowledge>
    | l.$Typed<ModEventEscalate>
    | l.$Typed<ModEventMute>
    | l.$Typed<ModEventUnmute>
    | l.$Typed<ModEventMuteReporter>
    | l.$Typed<ModEventUnmuteReporter>
    | l.$Typed<ModEventEmail>
    | l.$Typed<ModEventResolveAppeal>
    | l.$Typed<ModEventDivert>
    | l.$Typed<ModEventTag>
    | l.$Typed<AccountEvent>
    | l.$Typed<IdentityEvent>
    | l.$Typed<RecordEvent>
    | l.$Typed<ModEventPriorityScore>
    | l.$Typed<AgeAssuranceEvent>
    | l.$Typed<AgeAssuranceOverrideEvent>
    | l.$Typed<AgeAssurancePurgeEvent>
    | l.$Typed<RevokeAccountCredentialsEvent>
    | l.$Typed<ScheduleTakedownEvent>
    | l.$Typed<CancelScheduledTakedownEvent>
    | l.Unknown$TypedObject
  subject:
    | l.$Typed<AdminDefs.RepoRef>
    | l.$Typed<RepoStrongRef.Main>
    | l.$Typed<ConvoDefs.MessageRef>
    | l.Unknown$TypedObject
  subjectBlobCids: string[]
  createdBy: l.DidString
  createdAt: l.DatetimeString
  creatorHandle?: string
  subjectHandle?: string
  modTool?: ModTool
}

export type { ModEventView }

const modEventView = l.typedObject<ModEventView>(
  $nsid,
  'modEventView',
  l.object({
    id: l.integer(),
    event: l.typedUnion(
      [
        l.typedRef<ModEventTakedown>((() => modEventTakedown) as any),
        l.typedRef<ModEventReverseTakedown>(
          (() => modEventReverseTakedown) as any,
        ),
        l.typedRef<ModEventComment>((() => modEventComment) as any),
        l.typedRef<ModEventReport>((() => modEventReport) as any),
        l.typedRef<ModEventLabel>((() => modEventLabel) as any),
        l.typedRef<ModEventAcknowledge>((() => modEventAcknowledge) as any),
        l.typedRef<ModEventEscalate>((() => modEventEscalate) as any),
        l.typedRef<ModEventMute>((() => modEventMute) as any),
        l.typedRef<ModEventUnmute>((() => modEventUnmute) as any),
        l.typedRef<ModEventMuteReporter>((() => modEventMuteReporter) as any),
        l.typedRef<ModEventUnmuteReporter>(
          (() => modEventUnmuteReporter) as any,
        ),
        l.typedRef<ModEventEmail>((() => modEventEmail) as any),
        l.typedRef<ModEventResolveAppeal>((() => modEventResolveAppeal) as any),
        l.typedRef<ModEventDivert>((() => modEventDivert) as any),
        l.typedRef<ModEventTag>((() => modEventTag) as any),
        l.typedRef<AccountEvent>((() => accountEvent) as any),
        l.typedRef<IdentityEvent>((() => identityEvent) as any),
        l.typedRef<RecordEvent>((() => recordEvent) as any),
        l.typedRef<ModEventPriorityScore>((() => modEventPriorityScore) as any),
        l.typedRef<AgeAssuranceEvent>((() => ageAssuranceEvent) as any),
        l.typedRef<AgeAssuranceOverrideEvent>(
          (() => ageAssuranceOverrideEvent) as any,
        ),
        l.typedRef<AgeAssurancePurgeEvent>(
          (() => ageAssurancePurgeEvent) as any,
        ),
        l.typedRef<RevokeAccountCredentialsEvent>(
          (() => revokeAccountCredentialsEvent) as any,
        ),
        l.typedRef<ScheduleTakedownEvent>((() => scheduleTakedownEvent) as any),
        l.typedRef<CancelScheduledTakedownEvent>(
          (() => cancelScheduledTakedownEvent) as any,
        ),
      ],
      false,
    ),
    subject: l.typedUnion(
      [
        l.typedRef<AdminDefs.RepoRef>((() => AdminDefs.repoRef) as any),
        l.typedRef<RepoStrongRef.Main>((() => RepoStrongRef.main) as any),
        l.typedRef<ConvoDefs.MessageRef>((() => ConvoDefs.messageRef) as any),
      ],
      false,
    ),
    subjectBlobCids: l.array(l.string()),
    createdBy: l.string({ format: 'did' }),
    createdAt: l.string({ format: 'datetime' }),
    creatorHandle: l.optional(l.string()),
    subjectHandle: l.optional(l.string()),
    modTool: l.optional(l.ref<ModTool>((() => modTool) as any)),
  }),
)

export { modEventView }

type ModEventViewDetail = {
  $type?: 'tools.ozone.moderation.defs#modEventViewDetail'
  id: number
  event:
    | l.$Typed<ModEventTakedown>
    | l.$Typed<ModEventReverseTakedown>
    | l.$Typed<ModEventComment>
    | l.$Typed<ModEventReport>
    | l.$Typed<ModEventLabel>
    | l.$Typed<ModEventAcknowledge>
    | l.$Typed<ModEventEscalate>
    | l.$Typed<ModEventMute>
    | l.$Typed<ModEventUnmute>
    | l.$Typed<ModEventMuteReporter>
    | l.$Typed<ModEventUnmuteReporter>
    | l.$Typed<ModEventEmail>
    | l.$Typed<ModEventResolveAppeal>
    | l.$Typed<ModEventDivert>
    | l.$Typed<ModEventTag>
    | l.$Typed<AccountEvent>
    | l.$Typed<IdentityEvent>
    | l.$Typed<RecordEvent>
    | l.$Typed<ModEventPriorityScore>
    | l.$Typed<AgeAssuranceEvent>
    | l.$Typed<AgeAssuranceOverrideEvent>
    | l.$Typed<AgeAssurancePurgeEvent>
    | l.$Typed<RevokeAccountCredentialsEvent>
    | l.$Typed<ScheduleTakedownEvent>
    | l.$Typed<CancelScheduledTakedownEvent>
    | l.Unknown$TypedObject
  subject:
    | l.$Typed<RepoView>
    | l.$Typed<RepoViewNotFound>
    | l.$Typed<RecordView>
    | l.$Typed<RecordViewNotFound>
    | l.Unknown$TypedObject
  subjectBlobs: BlobView[]
  createdBy: l.DidString
  createdAt: l.DatetimeString
  modTool?: ModTool
}

export type { ModEventViewDetail }

const modEventViewDetail = l.typedObject<ModEventViewDetail>(
  $nsid,
  'modEventViewDetail',
  l.object({
    id: l.integer(),
    event: l.typedUnion(
      [
        l.typedRef<ModEventTakedown>((() => modEventTakedown) as any),
        l.typedRef<ModEventReverseTakedown>(
          (() => modEventReverseTakedown) as any,
        ),
        l.typedRef<ModEventComment>((() => modEventComment) as any),
        l.typedRef<ModEventReport>((() => modEventReport) as any),
        l.typedRef<ModEventLabel>((() => modEventLabel) as any),
        l.typedRef<ModEventAcknowledge>((() => modEventAcknowledge) as any),
        l.typedRef<ModEventEscalate>((() => modEventEscalate) as any),
        l.typedRef<ModEventMute>((() => modEventMute) as any),
        l.typedRef<ModEventUnmute>((() => modEventUnmute) as any),
        l.typedRef<ModEventMuteReporter>((() => modEventMuteReporter) as any),
        l.typedRef<ModEventUnmuteReporter>(
          (() => modEventUnmuteReporter) as any,
        ),
        l.typedRef<ModEventEmail>((() => modEventEmail) as any),
        l.typedRef<ModEventResolveAppeal>((() => modEventResolveAppeal) as any),
        l.typedRef<ModEventDivert>((() => modEventDivert) as any),
        l.typedRef<ModEventTag>((() => modEventTag) as any),
        l.typedRef<AccountEvent>((() => accountEvent) as any),
        l.typedRef<IdentityEvent>((() => identityEvent) as any),
        l.typedRef<RecordEvent>((() => recordEvent) as any),
        l.typedRef<ModEventPriorityScore>((() => modEventPriorityScore) as any),
        l.typedRef<AgeAssuranceEvent>((() => ageAssuranceEvent) as any),
        l.typedRef<AgeAssuranceOverrideEvent>(
          (() => ageAssuranceOverrideEvent) as any,
        ),
        l.typedRef<AgeAssurancePurgeEvent>(
          (() => ageAssurancePurgeEvent) as any,
        ),
        l.typedRef<RevokeAccountCredentialsEvent>(
          (() => revokeAccountCredentialsEvent) as any,
        ),
        l.typedRef<ScheduleTakedownEvent>((() => scheduleTakedownEvent) as any),
        l.typedRef<CancelScheduledTakedownEvent>(
          (() => cancelScheduledTakedownEvent) as any,
        ),
      ],
      false,
    ),
    subject: l.typedUnion(
      [
        l.typedRef<RepoView>((() => repoView) as any),
        l.typedRef<RepoViewNotFound>((() => repoViewNotFound) as any),
        l.typedRef<RecordView>((() => recordView) as any),
        l.typedRef<RecordViewNotFound>((() => recordViewNotFound) as any),
      ],
      false,
    ),
    subjectBlobs: l.array(l.ref<BlobView>((() => blobView) as any)),
    createdBy: l.string({ format: 'did' }),
    createdAt: l.string({ format: 'datetime' }),
    modTool: l.optional(l.ref<ModTool>((() => modTool) as any)),
  }),
)

export { modEventViewDetail }

type SubjectStatusView = {
  $type?: 'tools.ozone.moderation.defs#subjectStatusView'
  id: number
  subject:
    | l.$Typed<AdminDefs.RepoRef>
    | l.$Typed<RepoStrongRef.Main>
    | l.$Typed<ConvoDefs.MessageRef>
    | l.Unknown$TypedObject
  hosting?:
    | l.$Typed<AccountHosting>
    | l.$Typed<RecordHosting>
    | l.Unknown$TypedObject
  subjectBlobCids?: l.CidString[]
  subjectRepoHandle?: string

  /**
   * Timestamp referencing when the last update was made to the moderation status of the subject
   */
  updatedAt: l.DatetimeString

  /**
   * Timestamp referencing the first moderation status impacting event was emitted on the subject
   */
  createdAt: l.DatetimeString
  reviewState: SubjectReviewState

  /**
   * Sticky comment on the subject.
   */
  comment?: string

  /**
   * Numeric value representing the level of priority. Higher score means higher priority.
   */
  priorityScore?: number
  muteUntil?: l.DatetimeString
  muteReportingUntil?: l.DatetimeString
  lastReviewedBy?: l.DidString
  lastReviewedAt?: l.DatetimeString
  lastReportedAt?: l.DatetimeString

  /**
   * Timestamp referencing when the author of the subject appealed a moderation action
   */
  lastAppealedAt?: l.DatetimeString
  takendown?: boolean

  /**
   * True indicates that the a previously taken moderator action was appealed against, by the author of the content. False indicates last appeal was resolved by moderators.
   */
  appealed?: boolean
  suspendUntil?: l.DatetimeString
  tags?: string[]

  /**
   * Statistics related to the account subject
   */
  accountStats?: AccountStats

  /**
   * Statistics related to the record subjects authored by the subject's account
   */
  recordsStats?: RecordsStats

  /**
   * Strike information for the account (account-level only)
   */
  accountStrike?: AccountStrike

  /**
   * Current age assurance state of the subject.
   */
  ageAssuranceState?:
    | 'pending'
    | 'assured'
    | 'unknown'
    | 'reset'
    | 'blocked'
    | l.UnknownString

  /**
   * Whether or not the last successful update to age assurance was made by the user or admin.
   */
  ageAssuranceUpdatedBy?: 'admin' | 'user' | l.UnknownString
}

export type { SubjectStatusView }

const subjectStatusView = l.typedObject<SubjectStatusView>(
  $nsid,
  'subjectStatusView',
  l.object({
    id: l.integer(),
    subject: l.typedUnion(
      [
        l.typedRef<AdminDefs.RepoRef>((() => AdminDefs.repoRef) as any),
        l.typedRef<RepoStrongRef.Main>((() => RepoStrongRef.main) as any),
        l.typedRef<ConvoDefs.MessageRef>((() => ConvoDefs.messageRef) as any),
      ],
      false,
    ),
    hosting: l.optional(
      l.typedUnion(
        [
          l.typedRef<AccountHosting>((() => accountHosting) as any),
          l.typedRef<RecordHosting>((() => recordHosting) as any),
        ],
        false,
      ),
    ),
    subjectBlobCids: l.optional(l.array(l.string({ format: 'cid' }))),
    subjectRepoHandle: l.optional(l.string()),
    updatedAt: l.string({ format: 'datetime' }),
    createdAt: l.string({ format: 'datetime' }),
    reviewState: l.ref<SubjectReviewState>((() => subjectReviewState) as any),
    comment: l.optional(l.string()),
    priorityScore: l.optional(l.integer({ minimum: 0, maximum: 100 })),
    muteUntil: l.optional(l.string({ format: 'datetime' })),
    muteReportingUntil: l.optional(l.string({ format: 'datetime' })),
    lastReviewedBy: l.optional(l.string({ format: 'did' })),
    lastReviewedAt: l.optional(l.string({ format: 'datetime' })),
    lastReportedAt: l.optional(l.string({ format: 'datetime' })),
    lastAppealedAt: l.optional(l.string({ format: 'datetime' })),
    takendown: l.optional(l.boolean()),
    appealed: l.optional(l.boolean()),
    suspendUntil: l.optional(l.string({ format: 'datetime' })),
    tags: l.optional(l.array(l.string())),
    accountStats: l.optional(l.ref<AccountStats>((() => accountStats) as any)),
    recordsStats: l.optional(l.ref<RecordsStats>((() => recordsStats) as any)),
    accountStrike: l.optional(
      l.ref<AccountStrike>((() => accountStrike) as any),
    ),
    ageAssuranceState: l.optional(
      l.string<{
        knownValues: ['pending', 'assured', 'unknown', 'reset', 'blocked']
      }>(),
    ),
    ageAssuranceUpdatedBy: l.optional(
      l.string<{ knownValues: ['admin', 'user'] }>(),
    ),
  }),
)

export { subjectStatusView }

/** Detailed view of a subject. For record subjects, the author's repo and profile will be returned. */
type SubjectView = {
  $type?: 'tools.ozone.moderation.defs#subjectView'
  type: ModerationDefs.SubjectType
  subject: string
  status?: SubjectStatusView
  repo?: RepoViewDetail
  profile?: l.Unknown$TypedObject
  record?: RecordViewDetail
}

export type { SubjectView }

/** Detailed view of a subject. For record subjects, the author's repo and profile will be returned. */
const subjectView = l.typedObject<SubjectView>(
  $nsid,
  'subjectView',
  l.object({
    type: l.ref<ModerationDefs.SubjectType>(
      (() => ModerationDefs.subjectType) as any,
    ),
    subject: l.string(),
    status: l.optional(
      l.ref<SubjectStatusView>((() => subjectStatusView) as any),
    ),
    repo: l.optional(l.ref<RepoViewDetail>((() => repoViewDetail) as any)),
    profile: l.optional(l.typedUnion([], false)),
    record: l.optional(
      l.ref<RecordViewDetail>((() => recordViewDetail) as any),
    ),
  }),
)

export { subjectView }

/** Statistics about a particular account subject */
type AccountStats = {
  $type?: 'tools.ozone.moderation.defs#accountStats'

  /**
   * Total number of reports on the account
   */
  reportCount?: number

  /**
   * Total number of appeals against a moderation action on the account
   */
  appealCount?: number

  /**
   * Number of times the account was suspended
   */
  suspendCount?: number

  /**
   * Number of times the account was escalated
   */
  escalateCount?: number

  /**
   * Number of times the account was taken down
   */
  takedownCount?: number
}

export type { AccountStats }

/** Statistics about a particular account subject */
const accountStats = l.typedObject<AccountStats>(
  $nsid,
  'accountStats',
  l.object({
    reportCount: l.optional(l.integer()),
    appealCount: l.optional(l.integer()),
    suspendCount: l.optional(l.integer()),
    escalateCount: l.optional(l.integer()),
    takedownCount: l.optional(l.integer()),
  }),
)

export { accountStats }

/** Statistics about a set of record subject items */
type RecordsStats = {
  $type?: 'tools.ozone.moderation.defs#recordsStats'

  /**
   * Cumulative sum of the number of reports on the items in the set
   */
  totalReports?: number

  /**
   * Number of items that were reported at least once
   */
  reportedCount?: number

  /**
   * Number of items that were escalated at least once
   */
  escalatedCount?: number

  /**
   * Number of items that were appealed at least once
   */
  appealedCount?: number

  /**
   * Total number of item in the set
   */
  subjectCount?: number

  /**
   * Number of item currently in "reviewOpen" or "reviewEscalated" state
   */
  pendingCount?: number

  /**
   * Number of item currently in "reviewNone" or "reviewClosed" state
   */
  processedCount?: number

  /**
   * Number of item currently taken down
   */
  takendownCount?: number
}

export type { RecordsStats }

/** Statistics about a set of record subject items */
const recordsStats = l.typedObject<RecordsStats>(
  $nsid,
  'recordsStats',
  l.object({
    totalReports: l.optional(l.integer()),
    reportedCount: l.optional(l.integer()),
    escalatedCount: l.optional(l.integer()),
    appealedCount: l.optional(l.integer()),
    subjectCount: l.optional(l.integer()),
    pendingCount: l.optional(l.integer()),
    processedCount: l.optional(l.integer()),
    takendownCount: l.optional(l.integer()),
  }),
)

export { recordsStats }

/** Strike information for an account */
type AccountStrike = {
  $type?: 'tools.ozone.moderation.defs#accountStrike'

  /**
   * Current number of active strikes (excluding expired strikes)
   */
  activeStrikeCount?: number

  /**
   * Total number of strikes ever received (including expired strikes)
   */
  totalStrikeCount?: number

  /**
   * Timestamp of the first strike received
   */
  firstStrikeAt?: l.DatetimeString

  /**
   * Timestamp of the most recent strike received
   */
  lastStrikeAt?: l.DatetimeString
}

export type { AccountStrike }

/** Strike information for an account */
const accountStrike = l.typedObject<AccountStrike>(
  $nsid,
  'accountStrike',
  l.object({
    activeStrikeCount: l.optional(l.integer()),
    totalStrikeCount: l.optional(l.integer()),
    firstStrikeAt: l.optional(l.string({ format: 'datetime' })),
    lastStrikeAt: l.optional(l.string({ format: 'datetime' })),
  }),
)

export { accountStrike }

type SubjectReviewState =
  | 'tools.ozone.moderation.defs#reviewOpen'
  | 'tools.ozone.moderation.defs#reviewEscalated'
  | 'tools.ozone.moderation.defs#reviewClosed'
  | 'tools.ozone.moderation.defs#reviewNone'
  | l.UnknownString

export type { SubjectReviewState }

const subjectReviewState = l.string<{
  knownValues: [
    'tools.ozone.moderation.defs#reviewOpen',
    'tools.ozone.moderation.defs#reviewEscalated',
    'tools.ozone.moderation.defs#reviewClosed',
    'tools.ozone.moderation.defs#reviewNone',
  ]
}>()

export { subjectReviewState }

/** Moderator review status of a subject: Open. Indicates that the subject needs to be reviewed by a moderator */
type ReviewOpen = 'tools.ozone.moderation.defs#reviewOpen'

export type { ReviewOpen }

/** Moderator review status of a subject: Open. Indicates that the subject needs to be reviewed by a moderator */
const reviewOpen = l.token($nsid, 'reviewOpen')

export { reviewOpen }

/** Moderator review status of a subject: Escalated. Indicates that the subject was escalated for review by a moderator */
type ReviewEscalated = 'tools.ozone.moderation.defs#reviewEscalated'

export type { ReviewEscalated }

/** Moderator review status of a subject: Escalated. Indicates that the subject was escalated for review by a moderator */
const reviewEscalated = l.token($nsid, 'reviewEscalated')

export { reviewEscalated }

/** Moderator review status of a subject: Closed. Indicates that the subject was already reviewed and resolved by a moderator */
type ReviewClosed = 'tools.ozone.moderation.defs#reviewClosed'

export type { ReviewClosed }

/** Moderator review status of a subject: Closed. Indicates that the subject was already reviewed and resolved by a moderator */
const reviewClosed = l.token($nsid, 'reviewClosed')

export { reviewClosed }

/** Moderator review status of a subject: Unnecessary. Indicates that the subject does not need a review at the moment but there is probably some moderation related metadata available for it */
type ReviewNone = 'tools.ozone.moderation.defs#reviewNone'

export type { ReviewNone }

/** Moderator review status of a subject: Unnecessary. Indicates that the subject does not need a review at the moment but there is probably some moderation related metadata available for it */
const reviewNone = l.token($nsid, 'reviewNone')

export { reviewNone }

/** Take down a subject permanently or temporarily */
type ModEventTakedown = {
  $type?: 'tools.ozone.moderation.defs#modEventTakedown'
  comment?: string

  /**
   * Indicates how long the takedown should be in effect before automatically expiring.
   */
  durationInHours?: number

  /**
   * If true, all other reports on content authored by this account will be resolved (acknowledged).
   */
  acknowledgeAccountSubjects?: boolean

  /**
   * Names/Keywords of the policies that drove the decision.
   */
  policies?: string[]

  /**
   * Severity level of the violation (e.g., 'sev-0', 'sev-1', 'sev-2', etc.).
   */
  severityLevel?: string

  /**
   * List of services where the takedown should be applied. If empty or not provided, takedown is applied on all configured services.
   */
  targetServices?: ('appview' | 'pds' | l.UnknownString)[]

  /**
   * Number of strikes to assign to the user for this violation.
   */
  strikeCount?: number

  /**
   * When the strike should expire. If not provided, the strike never expires.
   */
  strikeExpiresAt?: l.DatetimeString
}

export type { ModEventTakedown }

/** Take down a subject permanently or temporarily */
const modEventTakedown = l.typedObject<ModEventTakedown>(
  $nsid,
  'modEventTakedown',
  l.object({
    comment: l.optional(l.string()),
    durationInHours: l.optional(l.integer()),
    acknowledgeAccountSubjects: l.optional(l.boolean()),
    policies: l.optional(l.array(l.string(), { maxLength: 5 })),
    severityLevel: l.optional(l.string()),
    targetServices: l.optional(
      l.array(l.string<{ knownValues: ['appview', 'pds'] }>()),
    ),
    strikeCount: l.optional(l.integer()),
    strikeExpiresAt: l.optional(l.string({ format: 'datetime' })),
  }),
)

export { modEventTakedown }

/** Revert take down action on a subject */
type ModEventReverseTakedown = {
  $type?: 'tools.ozone.moderation.defs#modEventReverseTakedown'

  /**
   * Describe reasoning behind the reversal.
   */
  comment?: string

  /**
   * Names/Keywords of the policy infraction for which takedown is being reversed.
   */
  policies?: string[]

  /**
   * Severity level of the violation. Usually set from the last policy infraction's severity.
   */
  severityLevel?: string

  /**
   * Number of strikes to subtract from the user's strike count. Usually set from the last policy infraction's severity.
   */
  strikeCount?: number
}

export type { ModEventReverseTakedown }

/** Revert take down action on a subject */
const modEventReverseTakedown = l.typedObject<ModEventReverseTakedown>(
  $nsid,
  'modEventReverseTakedown',
  l.object({
    comment: l.optional(l.string()),
    policies: l.optional(l.array(l.string(), { maxLength: 5 })),
    severityLevel: l.optional(l.string()),
    strikeCount: l.optional(l.integer()),
  }),
)

export { modEventReverseTakedown }

/** Resolve appeal on a subject */
type ModEventResolveAppeal = {
  $type?: 'tools.ozone.moderation.defs#modEventResolveAppeal'

  /**
   * Describe resolution.
   */
  comment?: string
}

export type { ModEventResolveAppeal }

/** Resolve appeal on a subject */
const modEventResolveAppeal = l.typedObject<ModEventResolveAppeal>(
  $nsid,
  'modEventResolveAppeal',
  l.object({ comment: l.optional(l.string()) }),
)

export { modEventResolveAppeal }

/** Add a comment to a subject. An empty comment will clear any previously set sticky comment. */
type ModEventComment = {
  $type?: 'tools.ozone.moderation.defs#modEventComment'
  comment?: string

  /**
   * Make the comment persistent on the subject
   */
  sticky?: boolean
}

export type { ModEventComment }

/** Add a comment to a subject. An empty comment will clear any previously set sticky comment. */
const modEventComment = l.typedObject<ModEventComment>(
  $nsid,
  'modEventComment',
  l.object({
    comment: l.optional(l.string()),
    sticky: l.optional(l.boolean()),
  }),
)

export { modEventComment }

/** Report a subject */
type ModEventReport = {
  $type?: 'tools.ozone.moderation.defs#modEventReport'
  comment?: string

  /**
   * Set to true if the reporter was muted from reporting at the time of the event. These reports won't impact the reviewState of the subject.
   */
  isReporterMuted?: boolean
  reportType: ModerationDefs.ReasonType
}

export type { ModEventReport }

/** Report a subject */
const modEventReport = l.typedObject<ModEventReport>(
  $nsid,
  'modEventReport',
  l.object({
    comment: l.optional(l.string()),
    isReporterMuted: l.optional(l.boolean()),
    reportType: l.ref<ModerationDefs.ReasonType>(
      (() => ModerationDefs.reasonType) as any,
    ),
  }),
)

export { modEventReport }

/** Apply/Negate labels on a subject */
type ModEventLabel = {
  $type?: 'tools.ozone.moderation.defs#modEventLabel'
  comment?: string
  createLabelVals: string[]
  negateLabelVals: string[]

  /**
   * Indicates how long the label will remain on the subject. Only applies on labels that are being added.
   */
  durationInHours?: number
}

export type { ModEventLabel }

/** Apply/Negate labels on a subject */
const modEventLabel = l.typedObject<ModEventLabel>(
  $nsid,
  'modEventLabel',
  l.object({
    comment: l.optional(l.string()),
    createLabelVals: l.array(l.string()),
    negateLabelVals: l.array(l.string()),
    durationInHours: l.optional(l.integer()),
  }),
)

export { modEventLabel }

/** Set priority score of the subject. Higher score means higher priority. */
type ModEventPriorityScore = {
  $type?: 'tools.ozone.moderation.defs#modEventPriorityScore'
  comment?: string
  score: number
}

export type { ModEventPriorityScore }

/** Set priority score of the subject. Higher score means higher priority. */
const modEventPriorityScore = l.typedObject<ModEventPriorityScore>(
  $nsid,
  'modEventPriorityScore',
  l.object({
    comment: l.optional(l.string()),
    score: l.integer({ minimum: 0, maximum: 100 }),
  }),
)

export { modEventPriorityScore }

/** Age assurance info coming directly from users. Only works on DID subjects. */
type AgeAssuranceEvent = {
  $type?: 'tools.ozone.moderation.defs#ageAssuranceEvent'

  /**
   * The date and time of this write operation.
   */
  createdAt: l.DatetimeString

  /**
   * The unique identifier for this instance of the age assurance flow, in UUID format.
   */
  attemptId: string

  /**
   * The status of the Age Assurance process.
   */
  status: 'unknown' | 'pending' | 'assured' | l.UnknownString
  access?: AgeassuranceDefs.Access

  /**
   * The ISO 3166-1 alpha-2 country code provided when beginning the Age Assurance flow.
   */
  countryCode?: string

  /**
   * The ISO 3166-2 region code provided when beginning the Age Assurance flow.
   */
  regionCode?: string

  /**
   * The IP address used when initiating the AA flow.
   */
  initIp?: string

  /**
   * The user agent used when initiating the AA flow.
   */
  initUa?: string

  /**
   * The IP address used when completing the AA flow.
   */
  completeIp?: string

  /**
   * The user agent used when completing the AA flow.
   */
  completeUa?: string
}

export type { AgeAssuranceEvent }

/** Age assurance info coming directly from users. Only works on DID subjects. */
const ageAssuranceEvent = l.typedObject<AgeAssuranceEvent>(
  $nsid,
  'ageAssuranceEvent',
  l.object({
    createdAt: l.string({ format: 'datetime' }),
    attemptId: l.string(),
    status: l.string<{ knownValues: ['unknown', 'pending', 'assured'] }>(),
    access: l.optional(
      l.ref<AgeassuranceDefs.Access>((() => AgeassuranceDefs.access) as any),
    ),
    countryCode: l.optional(l.string()),
    regionCode: l.optional(l.string()),
    initIp: l.optional(l.string()),
    initUa: l.optional(l.string()),
    completeIp: l.optional(l.string()),
    completeUa: l.optional(l.string()),
  }),
)

export { ageAssuranceEvent }

/** Age assurance status override by moderators. Only works on DID subjects. */
type AgeAssuranceOverrideEvent = {
  $type?: 'tools.ozone.moderation.defs#ageAssuranceOverrideEvent'

  /**
   * The status to be set for the user decided by a moderator, overriding whatever value the user had previously. Use reset to default to original state.
   */
  status: 'assured' | 'reset' | 'blocked' | l.UnknownString
  access?: AgeassuranceDefs.Access

  /**
   * Comment describing the reason for the override.
   */
  comment: string
}

export type { AgeAssuranceOverrideEvent }

/** Age assurance status override by moderators. Only works on DID subjects. */
const ageAssuranceOverrideEvent = l.typedObject<AgeAssuranceOverrideEvent>(
  $nsid,
  'ageAssuranceOverrideEvent',
  l.object({
    status: l.string<{ knownValues: ['assured', 'reset', 'blocked'] }>(),
    access: l.optional(
      l.ref<AgeassuranceDefs.Access>((() => AgeassuranceDefs.access) as any),
    ),
    comment: l.string({ minLength: 1 }),
  }),
)

export { ageAssuranceOverrideEvent }

/** Purges all age assurance events for the subject. Only works on DID subjects. Moderator-only. */
type AgeAssurancePurgeEvent = {
  $type?: 'tools.ozone.moderation.defs#ageAssurancePurgeEvent'

  /**
   * Comment describing the reason for the purge.
   */
  comment: string
}

export type { AgeAssurancePurgeEvent }

/** Purges all age assurance events for the subject. Only works on DID subjects. Moderator-only. */
const ageAssurancePurgeEvent = l.typedObject<AgeAssurancePurgeEvent>(
  $nsid,
  'ageAssurancePurgeEvent',
  l.object({ comment: l.string({ minLength: 1 }) }),
)

export { ageAssurancePurgeEvent }

/** Account credentials revocation by moderators. Only works on DID subjects. */
type RevokeAccountCredentialsEvent = {
  $type?: 'tools.ozone.moderation.defs#revokeAccountCredentialsEvent'

  /**
   * Comment describing the reason for the revocation.
   */
  comment: string
}

export type { RevokeAccountCredentialsEvent }

/** Account credentials revocation by moderators. Only works on DID subjects. */
const revokeAccountCredentialsEvent =
  l.typedObject<RevokeAccountCredentialsEvent>(
    $nsid,
    'revokeAccountCredentialsEvent',
    l.object({ comment: l.string({ minLength: 1 }) }),
  )

export { revokeAccountCredentialsEvent }

type ModEventAcknowledge = {
  $type?: 'tools.ozone.moderation.defs#modEventAcknowledge'
  comment?: string

  /**
   * If true, all other reports on content authored by this account will be resolved (acknowledged).
   */
  acknowledgeAccountSubjects?: boolean
}

export type { ModEventAcknowledge }

const modEventAcknowledge = l.typedObject<ModEventAcknowledge>(
  $nsid,
  'modEventAcknowledge',
  l.object({
    comment: l.optional(l.string()),
    acknowledgeAccountSubjects: l.optional(l.boolean()),
  }),
)

export { modEventAcknowledge }

type ModEventEscalate = {
  $type?: 'tools.ozone.moderation.defs#modEventEscalate'
  comment?: string
}

export type { ModEventEscalate }

const modEventEscalate = l.typedObject<ModEventEscalate>(
  $nsid,
  'modEventEscalate',
  l.object({ comment: l.optional(l.string()) }),
)

export { modEventEscalate }

/** Mute incoming reports on a subject */
type ModEventMute = {
  $type?: 'tools.ozone.moderation.defs#modEventMute'
  comment?: string

  /**
   * Indicates how long the subject should remain muted.
   */
  durationInHours: number
}

export type { ModEventMute }

/** Mute incoming reports on a subject */
const modEventMute = l.typedObject<ModEventMute>(
  $nsid,
  'modEventMute',
  l.object({ comment: l.optional(l.string()), durationInHours: l.integer() }),
)

export { modEventMute }

/** Unmute action on a subject */
type ModEventUnmute = {
  $type?: 'tools.ozone.moderation.defs#modEventUnmute'

  /**
   * Describe reasoning behind the reversal.
   */
  comment?: string
}

export type { ModEventUnmute }

/** Unmute action on a subject */
const modEventUnmute = l.typedObject<ModEventUnmute>(
  $nsid,
  'modEventUnmute',
  l.object({ comment: l.optional(l.string()) }),
)

export { modEventUnmute }

/** Mute incoming reports from an account */
type ModEventMuteReporter = {
  $type?: 'tools.ozone.moderation.defs#modEventMuteReporter'
  comment?: string

  /**
   * Indicates how long the account should remain muted. Falsy value here means a permanent mute.
   */
  durationInHours?: number
}

export type { ModEventMuteReporter }

/** Mute incoming reports from an account */
const modEventMuteReporter = l.typedObject<ModEventMuteReporter>(
  $nsid,
  'modEventMuteReporter',
  l.object({
    comment: l.optional(l.string()),
    durationInHours: l.optional(l.integer()),
  }),
)

export { modEventMuteReporter }

/** Unmute incoming reports from an account */
type ModEventUnmuteReporter = {
  $type?: 'tools.ozone.moderation.defs#modEventUnmuteReporter'

  /**
   * Describe reasoning behind the reversal.
   */
  comment?: string
}

export type { ModEventUnmuteReporter }

/** Unmute incoming reports from an account */
const modEventUnmuteReporter = l.typedObject<ModEventUnmuteReporter>(
  $nsid,
  'modEventUnmuteReporter',
  l.object({ comment: l.optional(l.string()) }),
)

export { modEventUnmuteReporter }

/** Keep a log of outgoing email to a user */
type ModEventEmail = {
  $type?: 'tools.ozone.moderation.defs#modEventEmail'

  /**
   * The subject line of the email sent to the user.
   */
  subjectLine: string

  /**
   * The content of the email sent to the user.
   */
  content?: string

  /**
   * Additional comment about the outgoing comm.
   */
  comment?: string

  /**
   * Names/Keywords of the policies that necessitated the email.
   */
  policies?: string[]

  /**
   * Severity level of the violation. Normally 'sev-1' that adds strike on repeat offense
   */
  severityLevel?: string

  /**
   * Number of strikes to assign to the user for this violation. Normally 0 as an indicator of a warning and only added as a strike on a repeat offense.
   */
  strikeCount?: number

  /**
   * When the strike should expire. If not provided, the strike never expires.
   */
  strikeExpiresAt?: l.DatetimeString

  /**
   * Indicates whether the email was successfully delivered to the user's inbox.
   */
  isDelivered?: boolean
}

export type { ModEventEmail }

/** Keep a log of outgoing email to a user */
const modEventEmail = l.typedObject<ModEventEmail>(
  $nsid,
  'modEventEmail',
  l.object({
    subjectLine: l.string(),
    content: l.optional(l.string()),
    comment: l.optional(l.string()),
    policies: l.optional(l.array(l.string(), { maxLength: 5 })),
    severityLevel: l.optional(l.string()),
    strikeCount: l.optional(l.integer()),
    strikeExpiresAt: l.optional(l.string({ format: 'datetime' })),
    isDelivered: l.optional(l.boolean()),
  }),
)

export { modEventEmail }

/** Divert a record's blobs to a 3rd party service for further scanning/tagging */
type ModEventDivert = {
  $type?: 'tools.ozone.moderation.defs#modEventDivert'
  comment?: string
}

export type { ModEventDivert }

/** Divert a record's blobs to a 3rd party service for further scanning/tagging */
const modEventDivert = l.typedObject<ModEventDivert>(
  $nsid,
  'modEventDivert',
  l.object({ comment: l.optional(l.string()) }),
)

export { modEventDivert }

/** Add/Remove a tag on a subject */
type ModEventTag = {
  $type?: 'tools.ozone.moderation.defs#modEventTag'

  /**
   * Tags to be added to the subject. If already exists, won't be duplicated.
   */
  add: string[]

  /**
   * Tags to be removed to the subject. Ignores a tag If it doesn't exist, won't be duplicated.
   */
  remove: string[]

  /**
   * Additional comment about added/removed tags.
   */
  comment?: string
}

export type { ModEventTag }

/** Add/Remove a tag on a subject */
const modEventTag = l.typedObject<ModEventTag>(
  $nsid,
  'modEventTag',
  l.object({
    add: l.array(l.string()),
    remove: l.array(l.string()),
    comment: l.optional(l.string()),
  }),
)

export { modEventTag }

/** Logs account status related events on a repo subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking. */
type AccountEvent = {
  $type?: 'tools.ozone.moderation.defs#accountEvent'
  comment?: string

  /**
   * Indicates that the account has a repository which can be fetched from the host that emitted this event.
   */
  active: boolean
  status?:
    | 'unknown'
    | 'deactivated'
    | 'deleted'
    | 'takendown'
    | 'suspended'
    | 'tombstoned'
    | l.UnknownString
  timestamp: l.DatetimeString
}

export type { AccountEvent }

/** Logs account status related events on a repo subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking. */
const accountEvent = l.typedObject<AccountEvent>(
  $nsid,
  'accountEvent',
  l.object({
    comment: l.optional(l.string()),
    active: l.boolean(),
    status: l.optional(
      l.string<{
        knownValues: [
          'unknown',
          'deactivated',
          'deleted',
          'takendown',
          'suspended',
          'tombstoned',
        ]
      }>(),
    ),
    timestamp: l.string({ format: 'datetime' }),
  }),
)

export { accountEvent }

/** Logs identity related events on a repo subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking. */
type IdentityEvent = {
  $type?: 'tools.ozone.moderation.defs#identityEvent'
  comment?: string
  handle?: l.HandleString
  pdsHost?: l.UriString
  tombstone?: boolean
  timestamp: l.DatetimeString
}

export type { IdentityEvent }

/** Logs identity related events on a repo subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking. */
const identityEvent = l.typedObject<IdentityEvent>(
  $nsid,
  'identityEvent',
  l.object({
    comment: l.optional(l.string()),
    handle: l.optional(l.string({ format: 'handle' })),
    pdsHost: l.optional(l.string({ format: 'uri' })),
    tombstone: l.optional(l.boolean()),
    timestamp: l.string({ format: 'datetime' }),
  }),
)

export { identityEvent }

/** Logs lifecycle event on a record subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking. */
type RecordEvent = {
  $type?: 'tools.ozone.moderation.defs#recordEvent'
  comment?: string
  op: 'create' | 'update' | 'delete' | l.UnknownString
  cid?: l.CidString
  timestamp: l.DatetimeString
}

export type { RecordEvent }

/** Logs lifecycle event on a record subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking. */
const recordEvent = l.typedObject<RecordEvent>(
  $nsid,
  'recordEvent',
  l.object({
    comment: l.optional(l.string()),
    op: l.string<{ knownValues: ['create', 'update', 'delete'] }>(),
    cid: l.optional(l.string({ format: 'cid' })),
    timestamp: l.string({ format: 'datetime' }),
  }),
)

export { recordEvent }

/** Logs a scheduled takedown action for an account. */
type ScheduleTakedownEvent = {
  $type?: 'tools.ozone.moderation.defs#scheduleTakedownEvent'
  comment?: string
  executeAt?: l.DatetimeString
  executeAfter?: l.DatetimeString
  executeUntil?: l.DatetimeString
}

export type { ScheduleTakedownEvent }

/** Logs a scheduled takedown action for an account. */
const scheduleTakedownEvent = l.typedObject<ScheduleTakedownEvent>(
  $nsid,
  'scheduleTakedownEvent',
  l.object({
    comment: l.optional(l.string()),
    executeAt: l.optional(l.string({ format: 'datetime' })),
    executeAfter: l.optional(l.string({ format: 'datetime' })),
    executeUntil: l.optional(l.string({ format: 'datetime' })),
  }),
)

export { scheduleTakedownEvent }

/** Logs cancellation of a scheduled takedown action for an account. */
type CancelScheduledTakedownEvent = {
  $type?: 'tools.ozone.moderation.defs#cancelScheduledTakedownEvent'
  comment?: string
}

export type { CancelScheduledTakedownEvent }

/** Logs cancellation of a scheduled takedown action for an account. */
const cancelScheduledTakedownEvent =
  l.typedObject<CancelScheduledTakedownEvent>(
    $nsid,
    'cancelScheduledTakedownEvent',
    l.object({ comment: l.optional(l.string()) }),
  )

export { cancelScheduledTakedownEvent }

type RepoView = {
  $type?: 'tools.ozone.moderation.defs#repoView'
  did: l.DidString
  handle: l.HandleString
  email?: string
  relatedRecords: l.LexMap[]
  indexedAt: l.DatetimeString
  moderation: Moderation
  invitedBy?: ServerDefs.InviteCode
  invitesDisabled?: boolean
  inviteNote?: string
  deactivatedAt?: l.DatetimeString
  threatSignatures?: AdminDefs.ThreatSignature[]
}

export type { RepoView }

const repoView = l.typedObject<RepoView>(
  $nsid,
  'repoView',
  l.object({
    did: l.string({ format: 'did' }),
    handle: l.string({ format: 'handle' }),
    email: l.optional(l.string()),
    relatedRecords: l.array(l.lexMap()),
    indexedAt: l.string({ format: 'datetime' }),
    moderation: l.ref<Moderation>((() => moderation) as any),
    invitedBy: l.optional(
      l.ref<ServerDefs.InviteCode>((() => ServerDefs.inviteCode) as any),
    ),
    invitesDisabled: l.optional(l.boolean()),
    inviteNote: l.optional(l.string()),
    deactivatedAt: l.optional(l.string({ format: 'datetime' })),
    threatSignatures: l.optional(
      l.array(
        l.ref<AdminDefs.ThreatSignature>(
          (() => AdminDefs.threatSignature) as any,
        ),
      ),
    ),
  }),
)

export { repoView }

type RepoViewDetail = {
  $type?: 'tools.ozone.moderation.defs#repoViewDetail'
  did: l.DidString
  handle: l.HandleString
  email?: string
  relatedRecords: l.LexMap[]
  indexedAt: l.DatetimeString
  moderation: ModerationDetail
  labels?: LabelDefs.Label[]
  invitedBy?: ServerDefs.InviteCode
  invites?: ServerDefs.InviteCode[]
  invitesDisabled?: boolean
  inviteNote?: string
  emailConfirmedAt?: l.DatetimeString
  deactivatedAt?: l.DatetimeString
  threatSignatures?: AdminDefs.ThreatSignature[]
}

export type { RepoViewDetail }

const repoViewDetail = l.typedObject<RepoViewDetail>(
  $nsid,
  'repoViewDetail',
  l.object({
    did: l.string({ format: 'did' }),
    handle: l.string({ format: 'handle' }),
    email: l.optional(l.string()),
    relatedRecords: l.array(l.lexMap()),
    indexedAt: l.string({ format: 'datetime' }),
    moderation: l.ref<ModerationDetail>((() => moderationDetail) as any),
    labels: l.optional(
      l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
    ),
    invitedBy: l.optional(
      l.ref<ServerDefs.InviteCode>((() => ServerDefs.inviteCode) as any),
    ),
    invites: l.optional(
      l.array(
        l.ref<ServerDefs.InviteCode>((() => ServerDefs.inviteCode) as any),
      ),
    ),
    invitesDisabled: l.optional(l.boolean()),
    inviteNote: l.optional(l.string()),
    emailConfirmedAt: l.optional(l.string({ format: 'datetime' })),
    deactivatedAt: l.optional(l.string({ format: 'datetime' })),
    threatSignatures: l.optional(
      l.array(
        l.ref<AdminDefs.ThreatSignature>(
          (() => AdminDefs.threatSignature) as any,
        ),
      ),
    ),
  }),
)

export { repoViewDetail }

type RepoViewNotFound = {
  $type?: 'tools.ozone.moderation.defs#repoViewNotFound'
  did: l.DidString
}

export type { RepoViewNotFound }

const repoViewNotFound = l.typedObject<RepoViewNotFound>(
  $nsid,
  'repoViewNotFound',
  l.object({ did: l.string({ format: 'did' }) }),
)

export { repoViewNotFound }

type RecordView = {
  $type?: 'tools.ozone.moderation.defs#recordView'
  uri: l.AtUriString
  cid: l.CidString
  value: l.LexMap
  blobCids: l.CidString[]
  indexedAt: l.DatetimeString
  moderation: Moderation
  repo: RepoView
}

export type { RecordView }

const recordView = l.typedObject<RecordView>(
  $nsid,
  'recordView',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    cid: l.string({ format: 'cid' }),
    value: l.lexMap(),
    blobCids: l.array(l.string({ format: 'cid' })),
    indexedAt: l.string({ format: 'datetime' }),
    moderation: l.ref<Moderation>((() => moderation) as any),
    repo: l.ref<RepoView>((() => repoView) as any),
  }),
)

export { recordView }

type RecordViewDetail = {
  $type?: 'tools.ozone.moderation.defs#recordViewDetail'
  uri: l.AtUriString
  cid: l.CidString
  value: l.LexMap
  blobs: BlobView[]
  labels?: LabelDefs.Label[]
  indexedAt: l.DatetimeString
  moderation: ModerationDetail
  repo: RepoView
}

export type { RecordViewDetail }

const recordViewDetail = l.typedObject<RecordViewDetail>(
  $nsid,
  'recordViewDetail',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    cid: l.string({ format: 'cid' }),
    value: l.lexMap(),
    blobs: l.array(l.ref<BlobView>((() => blobView) as any)),
    labels: l.optional(
      l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
    ),
    indexedAt: l.string({ format: 'datetime' }),
    moderation: l.ref<ModerationDetail>((() => moderationDetail) as any),
    repo: l.ref<RepoView>((() => repoView) as any),
  }),
)

export { recordViewDetail }

type RecordViewNotFound = {
  $type?: 'tools.ozone.moderation.defs#recordViewNotFound'
  uri: l.AtUriString
}

export type { RecordViewNotFound }

const recordViewNotFound = l.typedObject<RecordViewNotFound>(
  $nsid,
  'recordViewNotFound',
  l.object({ uri: l.string({ format: 'at-uri' }) }),
)

export { recordViewNotFound }

type Moderation = {
  $type?: 'tools.ozone.moderation.defs#moderation'
  subjectStatus?: SubjectStatusView
}

export type { Moderation }

const moderation = l.typedObject<Moderation>(
  $nsid,
  'moderation',
  l.object({
    subjectStatus: l.optional(
      l.ref<SubjectStatusView>((() => subjectStatusView) as any),
    ),
  }),
)

export { moderation }

type ModerationDetail = {
  $type?: 'tools.ozone.moderation.defs#moderationDetail'
  subjectStatus?: SubjectStatusView
}

export type { ModerationDetail }

const moderationDetail = l.typedObject<ModerationDetail>(
  $nsid,
  'moderationDetail',
  l.object({
    subjectStatus: l.optional(
      l.ref<SubjectStatusView>((() => subjectStatusView) as any),
    ),
  }),
)

export { moderationDetail }

type BlobView = {
  $type?: 'tools.ozone.moderation.defs#blobView'
  cid: l.CidString
  mimeType: string
  size: number
  createdAt: l.DatetimeString
  details?:
    | l.$Typed<ImageDetails>
    | l.$Typed<VideoDetails>
    | l.Unknown$TypedObject
  moderation?: Moderation
}

export type { BlobView }

const blobView = l.typedObject<BlobView>(
  $nsid,
  'blobView',
  l.object({
    cid: l.string({ format: 'cid' }),
    mimeType: l.string(),
    size: l.integer(),
    createdAt: l.string({ format: 'datetime' }),
    details: l.optional(
      l.typedUnion(
        [
          l.typedRef<ImageDetails>((() => imageDetails) as any),
          l.typedRef<VideoDetails>((() => videoDetails) as any),
        ],
        false,
      ),
    ),
    moderation: l.optional(l.ref<Moderation>((() => moderation) as any)),
  }),
)

export { blobView }

type ImageDetails = {
  $type?: 'tools.ozone.moderation.defs#imageDetails'
  width: number
  height: number
}

export type { ImageDetails }

const imageDetails = l.typedObject<ImageDetails>(
  $nsid,
  'imageDetails',
  l.object({ width: l.integer(), height: l.integer() }),
)

export { imageDetails }

type VideoDetails = {
  $type?: 'tools.ozone.moderation.defs#videoDetails'
  width: number
  height: number
  length: number
}

export type { VideoDetails }

const videoDetails = l.typedObject<VideoDetails>(
  $nsid,
  'videoDetails',
  l.object({ width: l.integer(), height: l.integer(), length: l.integer() }),
)

export { videoDetails }

type AccountHosting = {
  $type?: 'tools.ozone.moderation.defs#accountHosting'
  status:
    | 'takendown'
    | 'suspended'
    | 'deleted'
    | 'deactivated'
    | 'unknown'
    | l.UnknownString
  updatedAt?: l.DatetimeString
  createdAt?: l.DatetimeString
  deletedAt?: l.DatetimeString
  deactivatedAt?: l.DatetimeString
  reactivatedAt?: l.DatetimeString
}

export type { AccountHosting }

const accountHosting = l.typedObject<AccountHosting>(
  $nsid,
  'accountHosting',
  l.object({
    status: l.string<{
      knownValues: [
        'takendown',
        'suspended',
        'deleted',
        'deactivated',
        'unknown',
      ]
    }>(),
    updatedAt: l.optional(l.string({ format: 'datetime' })),
    createdAt: l.optional(l.string({ format: 'datetime' })),
    deletedAt: l.optional(l.string({ format: 'datetime' })),
    deactivatedAt: l.optional(l.string({ format: 'datetime' })),
    reactivatedAt: l.optional(l.string({ format: 'datetime' })),
  }),
)

export { accountHosting }

type RecordHosting = {
  $type?: 'tools.ozone.moderation.defs#recordHosting'
  status: 'deleted' | 'unknown' | l.UnknownString
  updatedAt?: l.DatetimeString
  createdAt?: l.DatetimeString
  deletedAt?: l.DatetimeString
}

export type { RecordHosting }

const recordHosting = l.typedObject<RecordHosting>(
  $nsid,
  'recordHosting',
  l.object({
    status: l.string<{ knownValues: ['deleted', 'unknown'] }>(),
    updatedAt: l.optional(l.string({ format: 'datetime' })),
    createdAt: l.optional(l.string({ format: 'datetime' })),
    deletedAt: l.optional(l.string({ format: 'datetime' })),
  }),
)

export { recordHosting }

type ReporterStats = {
  $type?: 'tools.ozone.moderation.defs#reporterStats'
  did: l.DidString

  /**
   * The total number of reports made by the user on accounts.
   */
  accountReportCount: number

  /**
   * The total number of reports made by the user on records.
   */
  recordReportCount: number

  /**
   * The total number of accounts reported by the user.
   */
  reportedAccountCount: number

  /**
   * The total number of records reported by the user.
   */
  reportedRecordCount: number

  /**
   * The total number of accounts taken down as a result of the user's reports.
   */
  takendownAccountCount: number

  /**
   * The total number of records taken down as a result of the user's reports.
   */
  takendownRecordCount: number

  /**
   * The total number of accounts labeled as a result of the user's reports.
   */
  labeledAccountCount: number

  /**
   * The total number of records labeled as a result of the user's reports.
   */
  labeledRecordCount: number
}

export type { ReporterStats }

const reporterStats = l.typedObject<ReporterStats>(
  $nsid,
  'reporterStats',
  l.object({
    did: l.string({ format: 'did' }),
    accountReportCount: l.integer(),
    recordReportCount: l.integer(),
    reportedAccountCount: l.integer(),
    reportedRecordCount: l.integer(),
    takendownAccountCount: l.integer(),
    takendownRecordCount: l.integer(),
    labeledAccountCount: l.integer(),
    labeledRecordCount: l.integer(),
  }),
)

export { reporterStats }

/** Moderation tool information for tracing the source of the action */
type ModTool = {
  $type?: 'tools.ozone.moderation.defs#modTool'

  /**
   * Name/identifier of the source (e.g., 'automod', 'ozone/workspace')
   */
  name: string

  /**
   * Additional arbitrary metadata about the source
   */
  meta?: l.LexMap
}

export type { ModTool }

/** Moderation tool information for tracing the source of the action */
const modTool = l.typedObject<ModTool>(
  $nsid,
  'modTool',
  l.object({ name: l.string(), meta: l.optional(l.lexMap()) }),
)

export { modTool }

/** Moderation event timeline event for a PLC create operation */
type TimelineEventPlcCreate =
  'tools.ozone.moderation.defs#timelineEventPlcCreate'

export type { TimelineEventPlcCreate }

/** Moderation event timeline event for a PLC create operation */
const timelineEventPlcCreate = l.token($nsid, 'timelineEventPlcCreate')

export { timelineEventPlcCreate }

/** Moderation event timeline event for generic PLC operation */
type TimelineEventPlcOperation =
  'tools.ozone.moderation.defs#timelineEventPlcOperation'

export type { TimelineEventPlcOperation }

/** Moderation event timeline event for generic PLC operation */
const timelineEventPlcOperation = l.token($nsid, 'timelineEventPlcOperation')

export { timelineEventPlcOperation }

/** Moderation event timeline event for a PLC tombstone operation */
type TimelineEventPlcTombstone =
  'tools.ozone.moderation.defs#timelineEventPlcTombstone'

export type { TimelineEventPlcTombstone }

/** Moderation event timeline event for a PLC tombstone operation */
const timelineEventPlcTombstone = l.token($nsid, 'timelineEventPlcTombstone')

export { timelineEventPlcTombstone }

/** View of a scheduled moderation action */
type ScheduledActionView = {
  $type?: 'tools.ozone.moderation.defs#scheduledActionView'

  /**
   * Auto-incrementing row ID
   */
  id: number

  /**
   * Type of action to be executed
   */
  action: 'takedown' | l.UnknownString

  /**
   * Serialized event object that will be propagated to the event when performed
   */
  eventData?: l.LexMap

  /**
   * Subject DID for the action
   */
  did: l.DidString

  /**
   * Exact time to execute the action
   */
  executeAt?: l.DatetimeString

  /**
   * Earliest time to execute the action (for randomized scheduling)
   */
  executeAfter?: l.DatetimeString

  /**
   * Latest time to execute the action (for randomized scheduling)
   */
  executeUntil?: l.DatetimeString

  /**
   * Whether execution time should be randomized within the specified range
   */
  randomizeExecution?: boolean

  /**
   * DID of the user who created this scheduled action
   */
  createdBy: l.DidString

  /**
   * When the scheduled action was created
   */
  createdAt: l.DatetimeString

  /**
   * When the scheduled action was last updated
   */
  updatedAt?: l.DatetimeString

  /**
   * Current status of the scheduled action
   */
  status: 'pending' | 'executed' | 'cancelled' | 'failed' | l.UnknownString

  /**
   * When the action was last attempted to be executed
   */
  lastExecutedAt?: l.DatetimeString

  /**
   * Reason for the last execution failure
   */
  lastFailureReason?: string

  /**
   * ID of the moderation event created when action was successfully executed
   */
  executionEventId?: number
}

export type { ScheduledActionView }

/** View of a scheduled moderation action */
const scheduledActionView = l.typedObject<ScheduledActionView>(
  $nsid,
  'scheduledActionView',
  l.object({
    id: l.integer(),
    action: l.string<{ knownValues: ['takedown'] }>(),
    eventData: l.optional(l.lexMap()),
    did: l.string({ format: 'did' }),
    executeAt: l.optional(l.string({ format: 'datetime' })),
    executeAfter: l.optional(l.string({ format: 'datetime' })),
    executeUntil: l.optional(l.string({ format: 'datetime' })),
    randomizeExecution: l.optional(l.boolean()),
    createdBy: l.string({ format: 'did' }),
    createdAt: l.string({ format: 'datetime' }),
    updatedAt: l.optional(l.string({ format: 'datetime' })),
    status: l.string<{
      knownValues: ['pending', 'executed', 'cancelled', 'failed']
    }>(),
    lastExecutedAt: l.optional(l.string({ format: 'datetime' })),
    lastFailureReason: l.optional(l.string()),
    executionEventId: l.optional(l.integer()),
  }),
)

export { scheduledActionView }
